// Row 28.6 (partial) — "What's new" viewer, backed by the repo-owned CHANGELOG.md (source of
// truth — genuinely maintained, not fabricated). The NOTIFICATION half (an unread-entry badge)
// needs per-actor "last seen changelog version" persistence — a new DB column, migration-blocked
// this session — CFR'd (CFR-HELP01-03), not built here.
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@perlab/ui";
import { renderMarkdown } from "../../lib/docs/markdown";
import changelog from "../../../CHANGELOG.md?raw";

export interface ChangelogViewerProps {
  open: boolean;
  onClose: () => void;
}

export function ChangelogViewer({ open, onClose }: ChangelogViewerProps): ReactElement {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onClose} title={t("changelog.title")}>
      <div
        className="max-h-[60vh] overflow-y-auto text-sm text-[var(--color-text-primary)] [&_h1]:mb-2 [&_h1]:text-lg [&_h1]:font-semibold [&_h2]:mb-1.5 [&_h2]:mt-3 [&_h2]:text-sm [&_h2]:font-semibold [&_li]:mb-1 [&_p]:mb-2"
        // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in renderMarkdown
        dangerouslySetInnerHTML={{ __html: renderMarkdown(changelog) }}
      />
    </Modal>
  );
}
